export const BUILD_ALLOCATIONS = [
  {
    label: 'Elite Engineering Team + Founding Team',
    detail:
      '2 senior engineers + 1 ML/LLM specialist + 3 founding team members across the 12 month build phase and 12 months of post launch runway, plus commercial team capacity',
    portion: 45,
  },
  {
    label: 'Security, compliance & legal',
    detail:
      'ISO 27001, ISO/IEC 42001, Cyber Essentials Plus and UK GDPR readiness; penetration testing; cyber reviews',
    portion: 18,
  },
  {
    label: 'AI infra & integrations',
    detail: 'LLM API spend, AWS, Microsoft + Companies House integrations',
    portion: 16,
  },
  {
    label: 'Contingency reserve',
    detail: 'Schedule risk and pilot feedback rework headroom',
    portion: 15,
  },
  {
    label: 'Design, QA & pilot support',
    detail: 'Product UX, QA, white glove pilot onboarding',
    portion: 6,
  },
];

export const MILESTONES = [
  'Funds cover a 12 month build phase + 12 months of post launch runway',
  'AI driven workflow + transaction processing shipped to pilots by the end of the 12 month build phase',
  'Audit grade compliance certifications (ISO 27001, ISO/IEC 42001, Cyber Essentials Plus) in place',
  'First paying firms across one man band, mid tier and enterprise grade practices',
];
